import '../partials/content/reviews/reviews';
